import { ConcordiaNav } from '@maxpreps/apiserviceclients/apiModels';
import dynamic from 'next/dynamic';
import BreadcrumbList, {
  IBreadcrumbConfig
} from '../BreadcrumbList/BreadcrumbList';
import ThemeProvider from '../Styles/ThemeProvider';
import GlobalFooter from './GlobalFooter/GlobalFooter';
import GlobalHeader from './GlobalHeader';

const RouteProgressBar = dynamic(
  () => import('../RouteProgressBar/RouteProgressBar'),
  {
    ssr: false
  }
);

interface IGlobalLayoutProps {
  children: any;
  theme?: any;
  subheaders?: any[];
  siteNavData: ConcordiaNav;
  isFrameVisible?: boolean;
  breadcrumbConfig?: IBreadcrumbConfig;
}

const GlobalLayout: React.FC<IGlobalLayoutProps> = ({
  children,
  theme,
  subheaders = [],
  siteNavData,
  isFrameVisible = true,
  breadcrumbConfig = undefined
}) => (
  // likely should also auto-hide the 'static headers' when being viewed in the app
  // https://atlassian.cbsi.com/jira/browse/MP-10612
  <ThemeProvider theme={theme}>
    {/* @ts-ignore */}
    <RouteProgressBar />
    {isFrameVisible && (
      <GlobalHeader subheaders={subheaders} siteNavData={siteNavData} />
    )}
    {isFrameVisible && breadcrumbConfig && (
      <BreadcrumbList {...breadcrumbConfig} />
    )}
    {children}
    {isFrameVisible && <GlobalFooter />}
  </ThemeProvider>
);

export default GlobalLayout;
